/**
 * Tọa độ trọng tâm gần trung tâm hành chính từng tỉnh/TP.
 * Định dạng mỗi phần tử: **[Kinh độ (lng), Vĩ độ (lat)]** — Mapbox `center` / `flyTo` dùng `[lng, lat]`.
 * Key theo `province.code` (open-api / TCTK), đã chuẩn hoá bằng `normalizeProvinceProvinceCode`.
 * (Rà soát: toàn bộ cặp nằm ~102–111°Đ, ~8°23’B — không đảo lon/lat.)
 */

export const PROVINCE_CENTER_BY_PROVINCE_CODE: Record<string, readonly [number, number]> = {
  /** Thành phố Hà Nội (mã `"01"` / `1` / `01`) */
  '1': [105.8342, 21.0278],
  /** Tỉnh Hà Giang */
  '2': [104.9837, 22.823],
  /** Tỉnh Cao Bằng */
  '4': [106.2525, 22.666],
  /** Tỉnh Bắc Kạn */
  '6': [105.8348, 22.147],
  /** Tỉnh Tuyên Quang */
  '8': [105.2188, 21.823],
  /** Tỉnh Lào Cai */
  '10': [103.9759, 21.9914],

  '97': [103.0167, 21.3863],
  /** Tỉnh Lai Châu */
  '12': [103.125, 22.3964],
  /** Tỉnh Sơn La */
  '14': [104.9788, 21.325],
  /** Tỉnh Yên Bái */
  '15': [104.9192, 21.7053],
  /** Tỉnh Hoà Bình */
  '17': [105.3388, 20.8172],
  /** Tỉnh Thái Nguyên */
  '19': [105.8472, 21.5928],
  /** Tỉnh Lạng Sơn */
  '20': [106.7547, 21.8536],
  /** Tỉnh Quảng Ninh */
  '22': [107.0738, 21.006],
  /** Tỉnh Bắc Giang */
  '24': [106.0718, 21.272],
  /** Tỉnh Phú Thọ */
  '25': [105.2252, 21.3166],
  /** Tỉnh Vĩnh Phúc */
  '26': [105.5964, 21.3609],
  /** Tỉnh Bắc Ninh */
  '27': [106.0767, 21.186],
  /** Tỉnh Hải Dương */
  '30': [106.3333, 20.9373],
  /** Thành phố Hải Phòng */
  '31': [106.6881, 20.8449],
  /** Tỉnh Hưng Yên */
  '33': [106.0518, 20.646],
  /** Tỉnh Thái Bình */
  '34': [106.3361, 20.446],
  /** Tỉnh Hà Nam */
  '35': [105.9226, 20.534],
  /** Tỉnh Nam Định */
  '36': [106.0642, 20.4201],
  /** Tỉnh Ninh Bình */
  '37': [105.9801, 20.2505],
  /** Tỉnh Thanh Hóa */
  '38': [105.7596, 19.8073],
  /** Tỉnh Nghệ An */
  '40': [105.6721, 18.6796],
  /** Tỉnh Hà Tĩnh */
  '42': [105.9051, 18.3433],
  /** Tỉnh Quảng Bình */
  '44': [106.613, 17.4685],
  /** Tỉnh Quảng Trị */
  '45': [106.8016, 17.0723],
  /** Thành phố Huế */
  '46': [107.5908, 16.4637],
  /** Thành phố Đà Nẵng */
  '48': [108.2022, 16.0544],
  /** Tỉnh Quảng Nam */
  '49': [108.0414, 15.5643],
  /** Tỉnh Quảng Ngãi */
  '51': [108.8193, 14.9985],
  /** Tỉnh Bình Định */
  '52': [109.2236, 13.7871],
  /** Tỉnh Phú Yên */
  '54': [109.0952, 13.0957],
  /** Tỉnh Khánh Hòa */
  '56': [109.1967, 12.2388],
  /** Tỉnh Ninh Thuận */
  '58': [108.9912, 11.5643],
  /** Tỉnh Bình Thuận */
  '60': [108.0986, 11.0904],
  /** Tỉnh Kon Tum */
  '62': [107.9994, 14.3497],
  /** Tỉnh Gia Lai */
  '64': [107.9851, 13.9714],
  /** Tỉnh Đắk Lắk */
  '66': [108.0583, 12.6662],
  /** Tỉnh Đắk Nông */
  '67': [107.611, 12.0096],
  /** Tỉnh Lâm Đồng */
  '68': [108.4419, 11.9404],
  /** Tỉnh Bình Phước */
  '70': [106.9612, 11.6484],
  /** Tỉnh Tây Ninh */
  '72': [106.0977, 11.3351],
  /** Tỉnh Bình Dương */
  '74': [106.665, 11.1714],
  /** Tỉnh Đồng Nai */
  '75': [107.1672, 10.9943],
  /** Tỉnh Bà Rịa – Vũng Tàu */
  '77': [107.2464, 10.5173],
  /** Thành phố Hồ Chí Minh */
  '79': [106.684, 10.7769],
  /** Tỉnh Long An */
  '80': [106.1123, 10.6085],
  /** Tỉnh Tiền Giang */
  '82': [106.3672, 10.3654],
  /** Tỉnh Bến Tre */
  '83': [106.3752, 10.1068],
  /** Tỉnh Trà Vinh */
  '84': [106.348, 9.9333],
  /** Tỉnh Vĩnh Long */
  '86': [105.9801, 10.2524],
  /** Tỉnh Đồng Tháp */
  '87': [105.7514, 10.507],
  /** Tỉnh An Giang */
  '89': [105.1259, 10.5216],
  /** Tỉnh Kiên Giang */
  '91': [105.0809, 9.8242],
  /** Thành phố Cần Thơ */
  '92': [105.8342, 10.0452],
  /** Tỉnh Hậu Giang */
  '93': [105.7825, 9.7579],
  /** Tỉnh Sóc Trăng */
  '94': [105.9716, 9.6025],
  /** Tỉnh Bạc Liêu */
  '95': [105.7311, 9.2514],
  /** Tỉnh Cà Mau */
  '96': [105.1944, 9.1526],
};

export const PROVINCE_CENTER_LOOKUP_ALIASES: Readonly<Record<string, string>> = {
  '11': '1',
};

export function normalizeProvinceProvinceCode(provinceId: string | number | null | undefined): string {
  if (provinceId === null || provinceId === undefined) return '';
  if (typeof provinceId === 'number') {
    if (!Number.isFinite(provinceId)) return '';
    return String(Math.trunc(provinceId));
  }
  const s = String(provinceId).trim();
  if (!s) return '';
  if (/^\d+$/.test(s)) {
    const n = Number.parseInt(s, 10);
    return Number.isFinite(n) ? String(n) : s;
  }
  return s;
}

export function getProvinceMapCenterLngLat(
  provinceId: string | number | null | undefined
): Readonly<{ lng: number; lat: number }> | null {
  const key = normalizeProvinceProvinceCode(provinceId);
  if (!key) return null;
  const canonicalKey = PROVINCE_CENTER_LOOKUP_ALIASES[key] ?? key;
  const pair = PROVINCE_CENTER_BY_PROVINCE_CODE[canonicalKey];
  if (!pair) return null;
  return { lng: pair[0], lat: pair[1] } as const;
}
